module.exports = __webpack_public_path__ + "media/application/images/company/founders/Colin-Stove-a04be438d6a0b54f6f8b3007e13c52d1.jpg";